import { alpha, Box, Card, CardContent, Chip, Typography } from "@mui/material";
import { TimetablePeriod } from "../types";
import { PlaceholderBadge } from "./PlaceholderBadge";
import { EmptyState } from "./EmptyState";
import { cardTitleSx, dashboardCardSx } from "../responsiveText";

type TodayTimetableCardProps = {
  periods: TimetablePeriod[];
};

export const TodayTimetableCard = ({ periods }: TodayTimetableCardProps) => {
  const today = new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" });

  return (
    <Card elevation={0} sx={dashboardCardSx}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="subtitle1" fontWeight={600} sx={cardTitleSx}>
              Today&rsquo;s Timetable
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {today}
            </Typography>
          </Box>
          <PlaceholderBadge />
        </Box>

        {periods.length === 0 ? (
          <EmptyState message="No periods scheduled" height={200} />
        ) : (
        <Box sx={{ mt: 1 }}>
          {periods.map((period, index) =>
            period.isBreak ? (
              <Typography key={index} variant="caption" sx={{ display: "block", pl: { xs: "70px", sm: "88px" }, py: 0.5, color: "text.disabled", fontStyle: "italic" }}>
                {period.subject} &middot; {period.time}
              </Typography>
            ) : (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  py: 1,
                  px: 1,
                  borderRadius: 1,
                  backgroundColor: period.isNow ? (theme) => alpha(theme.palette.primary.main, 0.08) : "transparent",
                }}
              >
                <Typography variant="caption" sx={{ width: { xs: 62, sm: 80 }, flexShrink: 0, color: "text.secondary", fontWeight: 500 }}>
                  {period.time}
                </Typography>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="body2" fontWeight={600}>
                    {period.subject}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {period.teacher} &middot; {period.room}
                  </Typography>
                </Box>
                {period.isNow && <Chip label="NOW" size="small" color="primary" sx={{ height: 20, fontSize: 10, fontWeight: 700 }} />}
              </Box>
            )
          )}
        </Box>
        )}
      </CardContent>
    </Card>
  );
};
